"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_1 = __importDefault(require("@App/navigation"));
const getCatalogPath = (isComplete, rightsHolderId, id) => isComplete
    ? navigation_1.default.rightholder.catalog.work(rightsHolderId, id)
    : navigation_1.default.rightholder.registrationDrafts.draft(rightsHolderId, id);
exports.default = getCatalogPath;
